import dayjs from "@/lib/helpers/dayjs";

/** Returns age in years from a MM/DD/YYYY formatted date, or "" if absent */
export function calculateAge(dob: string): number | "" {
  if (!dob) return "";

  return dayjs().diff(dayjs(dob, "MM/DD/YYYY"), "year");
}
